import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl } from 'constant'
import { RootState } from 'store/store'
import { getAuthToken } from 'utils/getAuthToken'
import { handlingErrorResponse } from 'utils/HandlingErrorResponse'
import { cityUrl, MasterDataEndpointConst, postalCodeUrl, stateUrl } from './const'
import {
    ICityRequestType, IPostalCodeRequestType, IResponseType,
    IStateRequestType, ILeaveType, ISalaryStatusType, IOvertimeStatusType,
    IContractStatusDataType, IDocumentType, IRolesType, IDesignaionDataType,
    IBranchesDataType, IStateTyep, ILeaveStatusType, IResourceType
} from './type'

export const masterDataApi = createApi({
    reducerPath: 'masterDataApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['MasterData'],
    endpoints: (builder) => ({
        GetCountry: builder.query<IResponseType<string[]>, void>({
            query: () => MasterDataEndpointConst.countries,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'Country' }]
        }),
        GetState: builder.query<IResponseType<IStateTyep[]>, IStateRequestType>({
            query: (params) => stateUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'State' }]
        }),
        GetCity: builder.query<IResponseType<string[]>, ICityRequestType>({
            query: (params) => cityUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'City' }]
        }),
        GetBranch: builder.query<IResponseType<IBranchesDataType[]>, void>({
            query: () => MasterDataEndpointConst.branches,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'Brnach' }]
        }),
        GetDesignaion: builder.query<IResponseType<IDesignaionDataType[]>, void>({
            query: () => MasterDataEndpointConst.getDesignation,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'Designaion' }]
        }),
        GetRoles: builder.query<IResponseType<IRolesType[]>, void>({
            query: () => MasterDataEndpointConst.roles,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'Roles' }]
        }),
        GetDocumentType: builder.query<IResponseType<IDocumentType[]>, void>({
            query: () => MasterDataEndpointConst.document,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'DocumentType' }]
        }),
        GetContractStatus: builder.query<IResponseType<IContractStatusDataType[]>, void>({
            query: () => MasterDataEndpointConst.getContractStatus,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'ContractStatus' }]
        }),
        GetOvertimeStatus: builder.query<IResponseType<IOvertimeStatusType[]>, void>({
            query: () => MasterDataEndpointConst.overtimeStatus,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'DocumentType' }]
        }),
        GetPostCode: builder.query<IResponseType<string[]>, IPostalCodeRequestType>({
            query: (params) => postalCodeUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'PostCode' }]
        }),
        GetLeaveType: builder.query<IResponseType<ILeaveType[]>, void>({
            query: () => MasterDataEndpointConst.getLeaveType,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'DocumentType' }]
        }),
        GetSalaryStatus: builder.query<IResponseType<ISalaryStatusType[]>, void>({
            query: () => MasterDataEndpointConst.salaryStatus,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'SalaryStatus' }]
        }),
        GetLeaveStatus: builder.query<IResponseType<ILeaveStatusType[]>, void>({
            query: () => MasterDataEndpointConst.leaveStatus,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'DocumentType' }]
        }),
        GetResourceType: builder.query<IResponseType<IResourceType[]>, void>({
            query: () => MasterDataEndpointConst.resourceType,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'MasterData', id: 'ResourceType' }]
        }),
    }),
})